<template>
<div class="chapter">
<div class="inner_page">
<h3 class="chapter">Praise for the Writing of Alyxandra Harvey</h3>
<h3 class="chapter">The Drake Chronicles</h3>
<p class="topindent1">“Vampires with bite and girls who bite back. A witty, exhilarating and fresh take on an old tale.” —Kelley Armstrong, <em class="italic">New York Times–</em>bestselling author</p>
<p class="topindent1">“Fabulous and fast-paced! … The perfect escape read.” —<em class="italic">RT Book Reviews</em> on <em class="italic">Hearts at Stake</em></p>
<p class="topindent1">“A smart mix of darkness and humor.” —<em class="italic">Publishers Weekly</em></p>
<h3 class="chapter">The Witches of London Trilogy</h3>
<p class="topindent1">“A gorgeously gothic and gripping novel.” —<em class="italic">The Guardian </em>on <em class="italic">The Secret Witch</em></p>
<p class="topindent1">“Spell casting and paranormal creatures enliven this Regency fiction, which offers a cast of strong, witty women fighting for a higher good, all while finding romance, dressing up prettily, and going to lots of parties.” —<em class="italic">Publishers Weekly </em>on <em class="italic">The Secret Witch</em></p>
<p class="topindent1">“The relationships in this book are the highlight. … I love how [Emma, Gretchen and Penelope] are always looking out for each other and are ready to kick butt at anyone.” —YA Midnight Reads.comon <em class="italic">The Secret Witch</em></p>
<p class="topindent1">“Will leave readers spellbound.” —DarkFaerieTales.com on <em class="italic">The Whisper Witch
</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Praise.vue?013077b1